import shellFeedback from "./shellFeedback";
import systemFeedback from "./systemFeedback";
import applicationFeedback from "./applicationFeedback";
import profileFeedback from "./profileFeedback";
import streamingFeedback from "./streamingFeedback";
import securityFeedback from "./securityFeedback";
import transferFeedback from "./transferFeedback";
import userFeedback from "./userFeedback";
import mediaLibraryFeedback from "./mediaLibraryFeedback";
import notificationFeedback from "./notificationFeedback";
import transfers from "./transfers";
import mediaLibrary from "./mediaLibrary";
import notificationContent from "./notificationContent";
import vpnManagement from "./vpnManagement";
import deleteProtection from "./deleteProtection";
import appTemplates from "./appTemplates";
import securityManagement from "./securityManagement";
import sslManagement from "./sslManagement";
import userManagement from "./userManagement";
import notificationAdmin from "./notificationAdmin";
import emailManagement from "./emailManagement";
import streamingPages from "./streamingPages";
import apiMetadata from "./apiMetadata";
import apiSettings from "./apiSettings";
import streamingSettings from "./streamingSettings";
import streamingDashboard from "./streamingDashboard";
import auditLogs from "./auditLogs";
import settingsManagement from "./settingsManagement";
import updates from "./updates";
import terminal from "./terminal";
import news from "./news";
import appMetrics from "./appMetrics";
import applicationControl from "./applicationControl";
import applicationMetadata from "./applicationMetadata";
import packageManagement from "./packageManagement";
import systemHardware from "./systemHardware";
import systemOperations from "./systemOperations";
import systemInsights from "./systemInsights";
import commandChannel from "./commandChannel";
import profileSupport from "./profileSupport";
import profileDiskUsage from "./profileDiskUsage";
import imageCropper from "./imageCropper";
import notificationSettings from "./notificationSettings";
import notifications from "./notifications";
import profileSecurity from "./profileSecurity";
import language from "./language";
import auth from "./auth";
import dashboard from "./dashboard";
import navigation from "./navigation";
import shell from "./shell";
import search from "./search";
import common from "./common";
import profile from "./profile";
import systemOverview from "./systemOverview";
export default { shellFeedback, systemFeedback, applicationFeedback, profileFeedback, streamingFeedback, securityFeedback, transferFeedback, userFeedback, mediaLibraryFeedback, notificationFeedback, transfers, mediaLibrary, notificationContent, vpnManagement, deleteProtection, appTemplates, securityManagement, sslManagement, userManagement, notificationAdmin, emailManagement, streamingPages, apiMetadata, apiSettings, streamingSettings, streamingDashboard, auditLogs, settingsManagement, updates, terminal, news, appMetrics, applicationControl, applicationMetadata, packageManagement, systemHardware, systemOperations, systemInsights, commandChannel, profileSupport, profileDiskUsage, imageCropper, notificationSettings, notifications, profileSecurity, profile, systemOverview, common, language, auth, dashboard, navigation, shell, search };
